<template>
  <div class="mgr-layout">
    <aside class="mgr-sidebar">
      <div class="mgr-brand">
        <span class="mgr-brand-logo"><i class="el-icon-monitor"></i></span>
        <span class="mgr-brand-text">后台管理</span>
      </div>
      <nav class="mgr-nav">
        <router-link to="/manager/users" class="mgr-nav-item" :class="{ active: $route.path === '/manager/users' }">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </router-link>
        <router-link to="/manager/logs" class="mgr-nav-item" :class="{ active: $route.path === '/manager/logs' }">
          <i class="el-icon-document"></i>
          <span>日志管理</span>
        </router-link>
      </nav>
      <div class="mgr-sidebar-foot">
        <router-link to="/shicigame" class="mgr-back-link">
          <i class="el-icon-back"></i>
          <span>返回前台</span>
        </router-link>
      </div>
    </aside>

    <div class="mgr-main">
      <header class="mgr-header">
        <div class="mgr-header-title">{{ pageTitle }}</div>
        <div class="mgr-header-user">
          <span class="mgr-username">
            <i class="el-icon-user-solid"></i>
            {{ username || '-' }}（{{ username ? '管理员' : '' }}）
          </span>
          <el-button size="small" plain @click="pwdVisible = true">修改密码</el-button>
          <el-button size="small" type="danger" plain @click="logout">退 出</el-button>
        </div>
      </header>

      <main class="mgr-content">
        <router-view />
      </main>
    </div>

    <manager-password-dialog
      :visible.sync="pwdVisible"
      :username="username"
      :require-old="true"
    />
  </div>
</template>

<script>
import ManagerPasswordDialog from './ManagerPasswordDialog.vue'

export default {
  name: 'ManagerLayout',
  components: {
    ManagerPasswordDialog
  },
  data() {
    return {
      username: '',
      pwdVisible: false
    }
  },
  computed: {
    pageTitle() {
      if (this.$route.path === '/manager/users') {
        return '用户管理'
      }
      if (this.$route.path === '/manager/logs') {
        return '日志管理'
      }
      return '后台管理'
    }
  },
  mounted() {
    this.refreshUser()
    window.addEventListener('shicigame-auth-changed', this.refreshUser, false)
  },
  beforeDestroy() {
    window.removeEventListener('shicigame-auth-changed', this.refreshUser, false)
  },
  methods: {
    refreshUser() {
      try {
        const user = JSON.parse(localStorage.getItem('shicigame_user') || '{}') || {}
        this.username = user.role === 'admin' ? (user.username || '') : ''
      } catch (e) {
        this.username = ''
      }
    },
    logout() {
      localStorage.removeItem('shicigame_token')
      localStorage.removeItem('shicigame_user')
      this.username = ''
      window.dispatchEvent(new Event('shicigame-auth-changed'))
      this.$router.push('/manager/login')
    }
  }
}
</script>

<style scoped>
.mgr-layout {
  display: flex;
  min-height: 100vh;
  background: #f0f2f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.mgr-sidebar {
  display: flex;
  flex-direction: column;
  width: 220px;
  flex: 0 0 220px;
  background: #1f2633;
  color: #cfd6e4;
}

.mgr-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.mgr-brand-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  font-size: 18px;
  color: #fff;
  background: linear-gradient(135deg, #4f6bff 0%, #9b5cff 100%);
}

.mgr-brand-text {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #fff;
}

.mgr-nav {
  flex: 1;
  padding: 14px 10px;
}

.mgr-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  margin-bottom: 6px;
  border-radius: 8px;
  color: #cfd6e4;
  text-decoration: none;
  font-size: 14px;
  transition: background 0.2s ease, color 0.2s ease;
}

.mgr-nav-item:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.07);
}

.mgr-nav-item.active {
  color: #fff;
  background: linear-gradient(135deg, #4f6bff 0%, #7a5cff 100%);
  box-shadow: 0 6px 16px rgba(79, 107, 255, 0.35);
}

.mgr-sidebar-foot {
  padding: 14px 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.mgr-back-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8b95a9;
  font-size: 13px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.mgr-back-link:hover {
  color: #fff;
}

.mgr-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.mgr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 60px;
  padding: 0 24px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: sticky;
  top: 0;
  z-index: 10;
}

.mgr-header-title {
  font-size: 17px;
  font-weight: 600;
  color: #1f2633;
}

.mgr-header-user {
  display: flex;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
}

.mgr-username {
  font-size: 14px;
  color: #5a6474;
}

.mgr-content {
  flex: 1;
  padding: 24px;
  min-width: 0;
}

@media (max-width: 768px) {
  .mgr-layout {
    flex-direction: column;
  }

  .mgr-sidebar {
    width: 100%;
    flex: 0 0 auto;
  }

  .mgr-nav {
    display: flex;
    gap: 8px;
    padding: 10px 14px;
  }

  .mgr-nav-item {
    margin-bottom: 0;
  }

  .mgr-sidebar-foot {
    display: none;
  }

  .mgr-header {
    padding: 0 14px;
    flex-wrap: wrap;
    height: auto;
    min-height: 60px;
  }

  .mgr-username {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mgr-content {
    padding: 14px;
  }
}
</style>
